class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
    this.isSticky = this.dataset.isSticky || "no";
    this.productURL = this.dataset.url;
    this.productId = this.dataset.productId || '';
    this.isGiftCard = document.body.classList.contains('template-product.gift-card');

    waitForElement('.gvlo-trigger').then((el) => {
      this.handleGvlo(el)
    });

    this.updateOptions();
    this.showStatesOnLoad();
  }

  onVariantChange() {
    if (this.isProductCard()) {
      return this.updateProductCardVariantInput()
    }
    this.updateOptions();
    this.updateMasterId();
    this.handleAddButton();
    this.handleOOS();

    if (this.currentVariant) {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
    }
  }

  showStatesOnLoad() {
    const productVariants = this.getVariantData();
    const _this = this.isProductCard() ? this : document;
    const suffix = this.isProductCard() ? '-tile' : this.isSticky === 'no' ? '' : '-sticky';
    const options = [...this.querySelectorAll(".js-main-product-id option")];
    const allOption1s = [...new Set(options.map(({ dataset }) => dataset.option1))];
    const allOption2s = [...new Set(options.map(({ dataset }) => dataset.option2))];

    productVariants.map(variant => {
      const oosOption1s = options.filter(el => el.dataset.option2 == variant.option2 && el.classList.contains("oos")).map(el => el.dataset.option1);
      const oosOption2s = options.filter(el => el.dataset.option1 == variant.option1 && el.classList.contains("oos")).map(el => el.dataset.option2);

      const availableOption1s = options.filter(el => el.dataset.option2 == variant.option2).map(el => el.dataset.option1);
      const availableOption2s = options.filter(el => el.dataset.option1 == variant.option1).map(el => el.dataset.option2);

      const notOosOption1s = allOption2s.filter(option => !oosOption1s.includes(option));
      const notOosOption2s = allOption2s.filter(option => !oosOption2s.includes(option));

      const unavailableOption1s = notOosOption1s.filter(option => !availableOption1s.includes(option));
      const unavailableOption2s = notOosOption2s.filter(option => !availableOption2s.includes(option));

      const totalUnattainableOption1s = [...new Set(oosOption1s.concat(unavailableOption1s))];
      const totalUnattainableOption2s = [...new Set(oosOption2s.concat(unavailableOption2s))];

      // for a given option, if ALL its corresponding options are either OOS or do not exist, mark the given option as 'OOS'
      if (totalUnattainableOption1s.length === allOption1s.length) {
        _this.querySelector(`[data-option="option2${suffix}"] input[value="${variant.option2}"]`).classList.add('disabled');
      }
      if (totalUnattainableOption2s.length === allOption2s.length) {
        _this.querySelector(`[data-option="option1${suffix}"] input[value="${variant.option1}"]`).classList.add('disabled');
      }

      // for a given option, if ALL its corresponding options do not exist, mark the given option as 'Unavailable'
      if (unavailableOption1s.length === allOption1s.length) {
        _this.querySelector(`[data-option="option2${suffix}"] input[value="${variant.option2}"]`).classList.add('very-disabled');
      }
      if (unavailableOption2s.length === allOption2s.length) {
        _this.querySelector(`[data-option="option1${suffix}"] input[value="${variant.option1}"]`).classList.add('very-disabled');
      }
    })

    this.handleAddButton();
  }

  handleOOS() {
    if (!this.isProductCard()) {
      this.handleAddButton();
    }

    // given waist: option1, length: option2
    if (!this.currentVariant) {
      this.handleAddButton(true);
    }

    const _this = this.isProductCard() ? this : document;
    const suffix = this.isProductCard() ? '-tile' : this.isSticky === 'no' ? '' : '-sticky';
    const option1 = _this.querySelector(`[data-option="option1${suffix}"] input:checked`)?.value || (!this.isProductCard() && this.currentVariant?.option1) || null;
    const option2 = _this.querySelector(`[data-option="option2${suffix}"] input:checked`)?.value || (!this.isProductCard() && this.currentVariant?.option2) || null;
    const dataOption1Inputs = `[data-option="option1${suffix}"] input`
    const dataOption2Inputs = `[data-option="option2${suffix}"] input`

    // the options in the select dropdown of all variants that exist and whether they are OOS
    const options = [...this.querySelectorAll(".js-main-product-id option")];

    if (this.options.length === 2) {
      // holding option 1 steady, what values of option 2 are OOS? ex if the user chose waist: 28, what values of length are OOS?
      const option1steady = options.filter(el => el.dataset.option1 == option1 && el.classList.contains("oos")).map(el => el.dataset.option2);
      // holding option 2 steady, what values of option 1 are OOS? ex if the user chose length: 30, what values of waist are OOS?
      const option2steady = options.filter(el => el.dataset.option2 == option2 && el.classList.contains("oos")).map(el => el.dataset.option1);

      // given the user chose waist: 28, what values of length EXIST
      const allOption1s = options.filter(el => el.dataset.option1 == option1).map(el => el.dataset.option2);
      // given the user chose length: 30, what values of waist EXIST
      const allOption2s = options.filter(el => el.dataset.option2 == option2).map(el => el.dataset.option1);

      if (option1) {
        _this.querySelectorAll(`${dataOption2Inputs}`).forEach(item => {
          // for all length selectors,
          if (option1steady.indexOf(item.value) > -1) {
            // if the length is in the OOS list, make it OOS
            item.classList.add("disabled")
            item.classList.remove("very-disabled");
          } else if (allOption1s.indexOf(item.value) > -1) {
            // if the length is in the ALL LENGTHS THAT EXIST list, make it available
            item.classList.remove("disabled");
            item.classList.remove("very-disabled");
          } else {
            // if it's in neither list, it doesn't exist
            item.classList.add("disabled")
            item.classList.add("very-disabled");
          }
        })
      }

      if (option2) {
        _this.querySelectorAll(`${dataOption1Inputs}`).forEach(item => {
          if (option2steady.indexOf(item.value) > -1) {
            // item is oos
            item.classList.add("disabled")
            item.classList.remove("very-disabled");
          } else if (allOption2s.indexOf(item.value) > -1) {
            item.classList.remove("disabled");
            item.classList.remove("very-disabled");
          } else {
            item.classList.add("disabled")
            item.classList.add("very-disabled");
          }
        })
      }
    } else {
      const option1OOS = options.filter(el => el.classList.contains("oos")).map(el => el.dataset.option1);
      _this.querySelectorAll(`${dataOption1Inputs}`).forEach(item => {
        if (option1OOS.indexOf(item.value) > -1) {
          // item is oos
          item.classList.add("disabled");
        } else {
          item.classList.remove("disabled");
        }
      })
    }
  }

  handleGvlo(button) {
    button.addEventListener('click', function() {
      const modal = document.querySelector('#gvloModal');
      trapFocus(modal, null)
    });
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });

    if (this.querySelector(".js-main-product-id")) {
      this.querySelector(".js-main-product-id").value = this.currentVariant
        ? this.currentVariant.id
        : null
    }
  }

  updateMedia() {
    if (!this.currentVariant || !this.currentVariant?.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );
    if (!newMedia) return;
    const parent = newMedia.parentElement;
    parent.prepend(newMedia);
    window.setTimeout(() => { parent.scroll(0, 0) });
  }

  updateURL() {
    if (!this.currentVariant || this.isProductCard()) return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment, .js-sticky-atc-product-form, .js-main-product-form, .js-bis-form`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateProductCardVariantInput() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    const variantData = JSON.parse(this.querySelector('[type="application/json"]').textContent);
    const options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked)?.value;
    });
    this.options = options
    const currentVariant = variantData.find((variant) => {
      return !variant.options.map((option, index) => {
        return options[index] === option;
      }).includes(false);
    });
    if (!currentVariant) {
      this.handleOOS();
      return this.handleAddButton(true);
    }
    const input = this.nextElementSibling.querySelector('input[name="id"]')
    input.value = currentVariant ? currentVariant.id : null

    this.handleOOS();
    this.handleAddButton(false, currentVariant);
  }

  isProductCard() {
    return this.closest('.product-tile')
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;

        document.getElementById(`price-${this.dataset.section}`)?.classList.remove('visibility-hidden');
      });
  }

  handleAddButton(nonExistent, variant) {
    if (!variant) { variant = this.currentVariant }
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, .js-main-product-form, .js-sticky-atc-product-form, .js-tile-product-form`);

    productForms.forEach(productForm => {
      const addButtons = productForm.querySelectorAll('.js-atc-button');
      const bisButtons = productForm.querySelectorAll('.js-form-bis');
      const unattainableButtons = productForm.querySelectorAll('.js-unattainable-button');
      const productId = productForm.dataset.productId;

      if (!addButtons.length || !bisButtons.length || productId !== this.productId) return;

      if (nonExistent || this.options.includes(undefined)) {
        // doesn't exist
        unattainableButtons.forEach((button) => {
          button.classList.remove('hidden');
          button.textContent = this.options.includes(undefined) ? this.isGiftCard ? window.variantStrings.selectAnAmount : window.variantStrings.selectASize : window.variantStrings.unavailable
        });
        bisButtons.forEach((button) => button.classList.add('hidden'));
        addButtons.forEach((button) => button.classList.add('hidden'));
       } else if (variant && variant.inventory_quantity === 0 && !variant.available) {
        // Sold out / Get notified
        unattainableButtons.forEach((button) => button.classList.add('hidden'));
        bisButtons.forEach((button) => button.classList.remove('hidden'));
        addButtons.forEach((button) => button.classList.add('hidden'));
       } else {
        // Add to cart
        unattainableButtons.forEach((button) => button.classList.add('hidden'));
        bisButtons.forEach((button) => button.classList.add('hidden'));
        addButtons.forEach((button) => button.classList.remove('hidden'));
      }
    });
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked)?.value;
    });

    // if the user is selecting within the sticky atc, the change needs to be reflected within the main
    // product section, and the reverse. the product url is included to ensure that any quick shop
    // product tiles aren't affected
    const fieldSetsToChange =
      this.isSticky === "yes" ?
        document.querySelector(`variant-radios[data-is-sticky='no'][data-url='${this.productURL}']`)?.querySelectorAll("fieldset")
        : document.querySelector(`variant-radios[data-is-sticky='yes'][data-url='${this.productURL}']`)?.querySelectorAll("fieldset");

    if (fieldSetsToChange) {
      fieldSetsToChange.forEach((fieldset, index) => {
        const inputs = fieldset.querySelectorAll("input");
        inputs.forEach((el) => {
          el.checked = el.value === this.options[index]
        })
      })
    }
  }
}

customElements.define('variant-radios', VariantRadios);